import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import firebase from 'firebase';

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },

  // Account routes.
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/forgot',
    name: "Forgot Password",
    component: () => import('../views/ResetPassword.vue')
  },
  {
    path: '/payment',
    name: "Account Payment",
    component: () => import('../views/Payment.vue'),
    meta: {
      authRequired: false
    },
  },
  {
    path: '/paymentsuccess',
    name: "Payment Success",
    component: () => import('../views/PaymentSuccess.vue'),
    meta: {
      authRequired: false
    }
  },

  // Pie routes
  {
    path: '/pre-quiz',
    name: 'Pre-Quiz Questions',
    component: () => import('../views/PreQuiz.vue'),
    meta: {
      authRequired: false
    }
  },
  {
    path: '/initial',
    name: 'Initial Pie',
    component: () => import('../views/Initial.vue'),
    meta: {
      authRequired: false
    }
  },
  {
    path: '/general',
    name: 'Quiz',
    component: () => import('../views/General.vue'),
    meta: {
      authRequired: false
    }
  },
  {
    path: '/refined',
    name: 'Refining',
    component: () => import('../views/Refined.vue'),
    meta: {
      authRequired: false
    }
  },
  {
    path: '/people',
    name: 'People',
    component: () => import('../views/People.vue')
  },
  {
    path: '/results',
    name: 'Results',
    component: () => import('../views/Results.vue'),
    meta: {
      authRequired: false
    }
  },
  {
    path: '/share',
    name: 'Share',
    component: () => import('../views/Share.vue'),
    meta: {
      authRequired: false
    }
  },
  {
    path: '/share-pie',
    name: 'Share Pie',
    component: () => import('../views/PiePreview.vue'),
    meta: {
      authRequired: false
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      authRequired: false
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "G-SSZKFV8080" }
}, router);

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        next();
      } 
      else {
        alert('You must be logged in to see this page.');
        next({
            path: '/login',
        });
      }
    });

    /*if (firebase.auth().currentUser) {
        next();
    } else {
        alert('You must be logged in to see this page.');
        next({
            path: '/login',
        });
    }*/
  } 
  else {
    next();
  }
});

export default router
